__turbopack_context__.v({
  "distributedColumnWrapper": "distributed-column-module-scss-module__Ac0y6a__distributedColumnWrapper",
});
